var NATIVE_SYMBOL=require('../internals/native-symbol');module.exports=NATIVE_SYMBOL// eslint-disable-next-line no-undef
&&!Symbol.sham// eslint-disable-next-line no-undef
&&typeof Symbol()=='symbol';